// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAnSp1e8azJwv0pYMLoRmRpiroWwoy20hk",
  authDomain: "homepageseo-de105.firebaseapp.com",
  projectId: "homepageseo-de105",
  storageBucket: "homepageseo-de105.firebasestorage.app",
  messagingSenderId: "304198282844",
  appId: "1:304198282844:web:c9eddd5131bfd024380099"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

export default auth;